import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	dynamicBanners: [],
};

const dynamicBannersSlice = createSlice({
	name: 'dynamicBanners',
	initialState: initialState,
	reducers: {
		setDynamicBanners: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setDynamicBanners, reset } = dynamicBannersSlice.actions;

export default dynamicBannersSlice.reducer;